// extracted by mini-css-extract-plugin
module.exports = {"color_gray_05":"#20202C","color_gray_06":"#121220","color_black":"#0E0E19"};